module.exports = __webpack_public_path__ + "static/NewsHero-30760747ebbc230fa5f097caa915f226.svg";